import { Dd, Dl, Dt, H1, Skeleton } from '@dnb/eufemia';
import { ClientFromAllSourcesDto } from '@portals/shared/admin/ClientDto';
import Markdown from '@portals/shared-frontend/components/Markdown';
import { type JSX } from 'react';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';

import BackButton from '@/components/BackButton';
import Container from '@/components/Container';
import LoadingModal from '@/components/LoadingModal';

export default function ClientView(): JSX.Element {
  const { clientId } = useParams();

  const { data: client, isValidating: clientLoading } = useSWR<ClientFromAllSourcesDto>(
    clientId ? `/clients/${clientId}` : null,
  );

  return (
    <Skeleton show={clientLoading}>
      {clientLoading && <LoadingModal />}
      <BackButton to="/clients">Clients</BackButton>
      <Container centered>
        <H1 top="large">OAuth Client</H1>
        <Dl top="large">
          <Dt>Id</Dt>
          <Dd>{client?.id}</Dd>
          <Dt>Env</Dt>
          <Dd>{client?.liveMode ? 'Live (CIAM Prod)' : 'Test (CIAM Uat)'}</Dd>

          <Dt>Client in portal</Dt>
          <Dd>
            {client?.portalClient ? (
              <Dd>
                <Markdown>{`\`\`\`json\n${JSON.stringify(client.portalClient, null, 2)}\n\`\`\``}</Markdown>
              </Dd>
            ) : (
              'Client has not been imported into portal'
            )}
          </Dd>

          <Dt>Client in ciam</Dt>
          <Dd>
            <Markdown>{`\`\`\`json\n${JSON.stringify(client?.ciamClient, null, 2)}\n\`\`\``}</Markdown>
          </Dd>
        </Dl>
      </Container>
    </Skeleton>
  );
}
